import "./chunk-EUXUH3YW.js";

// libs/ui-components/src/lib/modules/icon/icons/cross_24.svg.ts
import { svg } from "lit";
var cross24Svg = svg`
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path d="M18 6L6 18" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M6 6L18 18" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

`;
export {
  cross24Svg
};
//# sourceMappingURL=cross_24.svg-Y6TXDXMZ.js.map
